import {resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import DoctorsService from "@services/DoctorsService";

export const getDoctors = createAsyncThunk(
  "doctors",
  async (params, {rejectWithValue}) => {
    try {
      const response = await DoctorsService.getDoctors(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  selectedDoctors: null,
  doctors: [],
  page: 1,
  size: 5,
  sort: {value: "created_at", direction: "desc"},
  totalDoctors: null,
  totalPages: null,
  inactiveData: false,
  error: "",
  serverStatus: "",
  search: "",
};

const doctorsSlice = createSlice({
  name: "doctors",
  initialState,
  reducers: {
    setSelectedDoctors(state, action) {
      state.selectedDoctors = action.payload;
    },
    setPage(state, action) {
      state.page = Math.max(1, action.payload);
    },
    setSize(state, action) {
      state.size = action.payload;
    },
    setSort(state, action) {
      state.sort = action.payload;
    },
    setTotalPages(state, action) {
      state.totalPages = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setServerStatus(state, action) {
      state.serverStatus = action.payload;
    },
    setInactiveData(state, action) {
      state.inactiveData = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
      state.page = 1;
    },
    setTotalDoctors(state, action) {
      state.totalDoctors = action.payload;
    },
    decrementTotalDoctors(state) {
      state.totalDoctors -= 1;
    },
    clearDoctors() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDoctors.pending, (state) => {
        state.serverStatus = "loading";
        state.error = "";
      })
      .addCase(getDoctors.fulfilled, (state, action) => {
        const list =
          action.payload?.data ??
          action.payload?.doctor_profiles ??
          action.payload;
        state.doctors = Array.isArray(list) ? list : [];
        const total =
          action.payload?.total ??
          action.payload?.meta?.total ??
          action.payload?.total_count;
        state.totalDoctors = total != null ? total : state.totalDoctors;
        state.totalPages =
          total != null ? Math.ceil(total / state.size) : state.totalPages;
        state.error = "";
        state.serverStatus = "success";
      })
      .addCase(getDoctors.rejected, (state, action) => {
        state.error = action.payload?.message || "";
        state.serverStatus = "error";
      });
  },
});

export const {
  setPage,
  setSort,
  clearDoctors,
  setTotalPages,
  setSelectedDoctors,
  setInactiveData,
  setError,
  setSize,
  setServerStatus,
  setSearch,
  decrementTotalDoctors,
  setTotalDoctors,
} = doctorsSlice.actions;
export default doctorsSlice.reducer;
